// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ie","content":"Je","crumbsList":"Ke","dropdownsWrap":"Le"};